<template>
    <header class="gv-header">
        <div class="gv-content-bar">
            <router-link :to="{ name: 'Dashboard' }" class="gv-icon d-flex align-items-center">
                <img :src="logo" height="35">
            </router-link>
            <div class="gv-menu-bar">
                <router-link :to="{ name: 'Profile' }" class="gv-link rounded-pill" style="width: 130px;" v-if="user">
                    <i class="bi bi-people"></i>
                    <small class="ml-1">{{ user.name }}</small>
                </router-link>
                <span class="gv-link" @click="LOGOUT()">
                    <i class="bi bi-box-arrow-right"></i>
                </span>
                <span class="gv-banner" @click="SHOW()">
                    <i :class="collapse ? 'fas fa-times' : 'fas fa-bars'"></i>
                </span>
            </div>
        </div>
    </header>
</template>
<script>
import logo from '@/assets/img/logo.png'
export default {
    props: {
        user: {
            type: Object,
            default: () => { return null }
        },
        collapse: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            logo,
        }
    },
    methods:{
        SHOW: function(){
            let vue = this
            vue.$store.dispatch('COLLAPSE')
        },
        LOGOUT: function(){
            let vue = this
            axios({url: 'logout', method: 'GET' })
            .then((resp) => {
                vue.$store.dispatch('FINISH_USER')
                vue.$router.push({ name: 'Login' })
            })
            .catch((err) => {
                vue.$store.dispatch('FINISH_USER')
                vue.$router.push({ name: 'Login' })
            })
            .finally((resp) => {
                window.location.href = '/'
            })
        }
    }
}
</script>
<style>
.dropdown-menu.show{
    left: -20px !important;
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/layout/Header.vue